import { FormControl, FormHelperText, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ChangeEvent, FocusEvent, SyntheticEvent } from "react";

const sharedStyle = {
  borderRadius: "24px !important",
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1) !important",
  outline: "none !important",
  fontFamily: "Work Sans !important",
  paddingLeft: "10px",
  paddingRight: "10px",
}
const useStyle = makeStyles(() => ({
  inputStyle: {
    ...sharedStyle,
    height: "49px !important",
    marginBottom: "12px !important",
    width: "100%",
  },
  inputStylehalf: {
    width: "50% !important",
    height: "49px !important",
    marginBottom: "12px !important",
  },
  placeholderStyle: {
    "&[data-shrink='false']": {
      top: "-3px !important",
      fontStyle: "normal !important",
      fontWeight: "600 !important",
      fontSize: "12px !important",
      lineHeight: "22px !important",
      color: "#D3D3D3",
      marginLeft: "10px",
    },
    fontFamily: "Work Sans !important",
  },
}));

interface IInputControllerBank {
  name?: string;
  label: string;
  value?: string;
  type?: string;
  errors?: string;
  defaultValue?: string;
  touched?: boolean;
  placeholder?: string;
  isboxShadow?: boolean;
  autoComplete?: string;
  isfullWidth: boolean;
  required?: boolean;
  isDisabledCopy?: boolean;
  readonly?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => void;
  onKeyDown?: (e: SyntheticEvent) => void;
}

export default function InputControllerBank(props: IInputControllerBank) {
  const classes = useStyle();

  return (
    <FormControl fullWidth error={false} defaultValue={props.defaultValue}>
      <TextField
        id={props.label}
        autoComplete={props.autoComplete}
        type={props.type}
        name={props.name}
        value={props.value}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        placeholder={props.placeholder}
        onBlur={props.onBlur}
        label={props.label}
        onKeyDown={props.onKeyDown}
        InputLabelProps={{
          className: classes.placeholderStyle,
        }}
        InputProps={{
          className: props.isfullWidth ? classes.inputStyle : classes.inputStylehalf,
          readOnly: props.readonly,
        }}
        onCut={(e) => props.isDisabledCopy && e.preventDefault()}
        onCopy={(e) => props.isDisabledCopy && e.preventDefault()}
        onPaste={(e) => props.isDisabledCopy && e.preventDefault()}
      />

      {props.errors && props.touched && (
        <FormHelperText style={{ marginTop: "-10px", marginBottom: "4px", fontSize: "11px" }} error>
          {" "}
          {props.errors}{" "}
        </FormHelperText>
      )}
    </FormControl>
  );
}
